export const MinimumGroupOrderSize = 2

export const UpcomingOrdersPagination = {
  InitialLimit: 20,
  LoadMoreLimit: 10,
}
